(() => {
  const key = 'yuuve-launch-wishlist-v1';
  function read() {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//')) : [];
    } catch { return []; }
  }
  function refresh() {
    const items = read();
    document.querySelectorAll('[data-launch-wishlist]').forEach(button => {
      const saved = items.some(item => item.id === button.dataset.launchWishlist);
      button.setAttribute('aria-pressed', String(saved));
      button.querySelector('[data-wishlist-label]').textContent = saved ? 'Remove from wishlist' : 'Add to wishlist';
    });
    document.querySelectorAll('[data-launch-wishlist-list]').forEach(list => {
      list.replaceChildren();
      if (!items.length) { const li = document.createElement('li'); li.textContent = 'Your wishlist is empty.'; list.append(li); }
      items.forEach(item => {
        const li = document.createElement('li');
        const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.dataset.launchRemove = item.id; remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
        li.append(link, remove); list.append(li);
      });
    });
    document.querySelectorAll('[data-launch-feedback]').forEach(message => { message.closest('details').open = true; });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-launch-wishlist], [data-launch-remove]');
    if (!button) return;
    const id = button.dataset.launchWishlist || button.dataset.launchRemove;
    const items = read(); const exists = items.some(item => item.id === id);
    const next = items.filter(item => item.id !== id);
    if (!exists && button.dataset.launchWishlist) next.push({ id, title: button.dataset.title, url: button.dataset.url });
    try { localStorage.setItem(key, JSON.stringify(next)); refresh(); }
    catch { button.closest('.coming-soon').querySelector('[data-wishlist-message]').textContent = 'Your browser could not save the wishlist. Please allow browser storage and try again.'; }
  });
  window.addEventListener('storage', refresh);
  document.addEventListener('shopify:section:load', refresh);
  new MutationObserver(records => { if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.coming-soon') || node.querySelector('.coming-soon'))))) refresh(); }).observe(document.body, { childList: true, subtree: true });
  refresh();
})();
